import { gql } from '@apollo/client'

import { FRAGMENT as PERSON_FRAGMENT } from 'src/components/Person'

export default gql`
  fragment TeamComponent on PersonList {
    nodes {
      ...PersonComponent
    }
  }

  ${PERSON_FRAGMENT}
`
